import { useAuth } from '@/features/auth/authContext'

/** Demo sessions carry no `capabilities`; these are the roles the backend grants `ANALYTICS_READ`. */
const ANALYTICS_ROLES: ReadonlySet<string> = new Set([
  'branch_manager',
  'franchise_partner',
  'company_admin',
])

export function roleCanViewAnalytics(roleKey: string | undefined): boolean {
  return roleKey !== undefined && ANALYTICS_ROLES.has(roleKey)
}

/**
 * The session's own `capabilities` decide when the server sends them (handoff §1); the role list
 * is only the fallback for a session that does not.
 */
export function canViewAnalytics(
  capabilities: readonly string[] | undefined,
  roleKey: string | undefined,
): boolean {
  return capabilities ? capabilities.includes('ANALYTICS_READ') : roleCanViewAnalytics(roleKey)
}

/**
 * Analysen needs `ANALYTICS_READ`: the Filialleiter and every tier above, never `branch_staff`,
 * who gets a 403 `CAPABILITY_REQUIRED`.
 *
 * This hides the entry; it does not replace handling the 403. The server decides, and a role
 * can change under a tab that has been open for hours.
 */
export function useCanViewAnalytics(): boolean {
  const { session, role } = useAuth()
  return canViewAnalytics(session?.capabilities, role?.key)
}
